module.exports = __webpack_public_path__ + "img/jellybean_blazer.f5e892b7.png";